import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import App from './App';
import { AppContextProvider } from './context/AppContext';
import axios from 'axios';

axios.defaults.baseURL = process.env.REACT_APP_API_URL;
axios.defaults.headers.post['Content-Type'] = 'application/json';

const ignoredEndpoints = [
  '/auth/nonce',
  '/marketplace/profile',
  '/ai/smart-description',
  '/marketplace/newsletter',
  '/logs/collect',
  '/profiles/',
];

// Add a request interceptor to add the token to the request's headers
axios.interceptors.request.use(
  async (config) => {
    // Check if the request URL matches any of the ignored endpoints
    const isIgnored = ignoredEndpoints.some((endpoint) =>
      config.url?.includes(endpoint)
    );

    if (isIgnored) {
      return config;
    }

    config.withCredentials = true;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor
axios.interceptors.response.use(
  (response) => {
    // If it's all good, return the response
    return response;
  },
  (error) => {
    // If we get any authorization errors, log the user out
    if (error.response && error.response.status === 403) {
      console.debug(
        'Invalid session. Please log in. Additional info:',
        error.response
      );
      // remove andee info
      document.cookie = 'andee=; maxAge=0';
      document.cookie = 'andSessionInfo=; maxAge=0';
      // redirect to login page
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <AppContextProvider>
    <App />
  </AppContextProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
